module.exports = __webpack_public_path__ + "img/loan-history-active.08ed4ae6.svg";